export const SERVICES = [
  {
    id: "s1",
    name: "Cardiology",
    slug: "cardiology",
    short_description: "Heart care & diagnostics",
    description: "Advanced cardiac care with 24/7 cath lab, ECG, echocardiography, and heart surgery led by board-certified specialists.",
    icon: "Heartbeat",
    image: "/images/services/cardiology.jpg",
    accent: "#E8ECE4"
  },
  {
    id: "s2",
    name: "Neurology",
    slug: "neurology",
    short_description: "Brain & nerve treatment",
    description: "Comprehensive care for stroke, epilepsy, headache, and complex neurological disorders using precise diagnostic imaging.",
    icon: "Brain",
    image: "/images/services/neurology.jpg",
    accent: "#F0E4DE"
  },
  {
    id: "s3",
    name: "Pediatrics",
    slug: "pediatrics",
    short_description: "Child & newborn care",
    description: "Gentle, expert care for infants, children, and adolescents. From routine checkups to specialty pediatric surgeries.",
    icon: "Baby",
    image: "/images/services/pediatrics.jpg",
    accent: "#E4E8EC"
  },
  {
    id: "s4",
    name: "Orthopedics",
    slug: "orthopedics",
    short_description: "Bones, joints & spine",
    description: "Joint replacement, spine surgery, sports injury, and arthroscopy performed by leading orthopedic surgeons.",
    icon: "Bone",
    image: "/images/services/orthopedics.jpg",
    accent: "#EFE9DD"
  },
  {
    id: "s5",
    name: "Emergency & Trauma",
    slug: "emergency",
    short_description: "24/7 critical care",
    description: "Round-the-clock emergency response with fully equipped trauma bays, ambulance service, and ICU support.",
    icon: "Ambulance",
    image: "/images/services/emergency.jpg",
    accent: "#F5DED6"
  },
  {
    id: "s6",
    name: "Oncology",
    slug: "oncology",
    short_description: "Cancer diagnosis & therapy",
    description: "Multidisciplinary cancer care with medical, surgical, and radiation oncology under one roof.",
    icon: "Microscope",
    image: "/images/services/oncology.jpg",
    accent: "#E8ECE4"
  },
  {
    id: "s7",
    name: "Maternity Care",
    slug: "maternity",
    short_description: "Pregnancy & delivery",
    description: "Personalized prenatal, delivery, and postnatal care in a warm, family-centered environment.",
    icon: "HeartStraight",
    image: "/images/services/maternity.jpg",
    accent: "#F0E4DE"
  },
  {
    id: "s8",
    name: "Diagnostics & Imaging",
    slug: "diagnostics",
    short_description: "MRI, CT, X-Ray, Lab",
    description: "State-of-the-art radiology and pathology labs with same-day reporting and expert interpretation.",
    icon: "Scan",
    image: "/images/services/diagnostics.jpg",
    accent: "#E4E8EC"
  }
];

export const DOCTORS = [
  {
    id: "d1",
    name: "Dr. Janak",
    specialty: "Interventional Cardiologist",
    department_slug: "cardiology",
    experience_years: 18,
    image: "/images/doctors/dr_janak.jpg",
    bio: "Dr. Janak leads the cath lab and specializes in angioplasty and structural heart interventions.",
    qualifications: ["MBBS - AIIMS Delhi", "MD Cardiology", "Fellowship - Cleveland Clinic"],
    languages: ["English", "Hindi", "Marathi"],
    consultation_days: ["Mon", "Wed", "Fri"]
  },
  {
    id: "d2",
    name: "Dr. Rohan Verma",
    specialty: "Consultant Neurologist",
    department_slug: "neurology",
    experience_years: 15,
    image: "/images/doctors/dr_rohan_verma.jpg",
    bio: "Expert in stroke management, epilepsy, and movement disorders with a research focus on neuro-imaging.",
    qualifications: ["MBBS - KEM Mumbai", "DM Neurology"],
    languages: ["English", "Hindi"],
    consultation_days: ["Tue", "Thu", "Sat"]
  },
  {
    id: "d3",
    name: "Dr. Meera Iyer",
    specialty: "Senior Pediatrician",
    department_slug: "pediatrics",
    experience_years: 20,
    image: "/images/doctors/dr_meera_iyer.jpg",
    bio: "Two decades of caring for children — from newborn NICU care to adolescent wellness.",
    qualifications: ["MBBS", "MD Pediatrics", "Fellowship in Neonatology"],
    languages: ["English", "Hindi", "Tamil"],
    consultation_days: ["Mon", "Tue", "Thu", "Fri"]
  },
  {
    id: "d4",
    name: "Dr. Karan Malhotra",
    specialty: "Orthopedic Surgeon",
    department_slug: "orthopedics",
    experience_years: 22,
    image: "/images/doctors/dr_karan_malhotra.jpg",
    bio: "Joint replacement and sports medicine specialist. Performed over 4,000 successful surgeries.",
    qualifications: ["MBBS", "MS Orthopedics", "Fellowship in Arthroscopy"],
    languages: ["English", "Hindi", "Punjabi"],
    consultation_days: ["Mon", "Wed", "Fri", "Sat"]
  },
  {
    id: "d5",
    name: "Dr. Priya Nair",
    specialty: "Emergency Physician",
    department_slug: "emergency",
    experience_years: 12,
    image: "/images/doctors/dr_priya_nair.jpg",
    bio: "Leads our trauma team with expertise in critical care and rapid emergency response.",
    qualifications: ["MBBS", "MD Emergency Medicine"],
    languages: ["English", "Hindi", "Malayalam"],
    consultation_days: ["24/7 on-call"]
  },
  {
    id: "d6",
    name: "Dr. Vikram Rao",
    specialty: "Medical Oncologist",
    department_slug: "oncology",
    experience_years: 17,
    image: "/images/doctors/dr_vikram_rao.jpg",
    bio: "Multidisciplinary cancer care with a focus on immunotherapy and personalized treatment plans.",
    qualifications: ["MBBS", "MD", "DM Medical Oncology"],
    languages: ["English", "Hindi", "Telugu"],
    consultation_days: ["Tue", "Wed", "Fri"]
  },
  {
    id: "d7",
    name: "Dr. Sana Qureshi",
    specialty: "Obstetrician & Gynecologist",
    department_slug: "maternity",
    experience_years: 14,
    image: "/images/doctors/dr_sana_qureshi.jpg",
    bio: "Compassionate maternity care from pregnancy planning through delivery and postpartum wellness.",
    qualifications: ["MBBS", "MS Obstetrics & Gynecology"],
    languages: ["English", "Hindi", "Urdu"],
    consultation_days: ["Mon", "Thu", "Sat"]
  },
  {
    id: "d8",
    name: "Dr. Aditya Ghosh",
    specialty: "Consultant Radiologist",
    department_slug: "diagnostics",
    experience_years: 16,
    image: "/images/doctors/dr_aditya_ghosh.jpg",
    bio: "Precise imaging interpretation across MRI, CT, ultrasound, and interventional radiology.",
    qualifications: ["MBBS", "MD Radiology"],
    languages: ["English", "Hindi", "Bengali"],
    consultation_days: ["Mon-Fri"]
  }
];

export const TESTIMONIALS = [
  {
    id: "t1",
    patient_name: "Anita Deshmukh",
    role: "Cardiac patient",
    quote: "The cardiology team didn't just treat my heart — they treated my fears. Dr. Sharma explained every step. I felt seen.",
    rating: 5,
    image: "/images/testimonials/anita_deshmukh.jpg"
  },
  {
    id: "t2",
    patient_name: "Rahul & Priya",
    role: "New parents",
    quote: "Our little one arrived safely thanks to the maternity team. The room felt like home, not a hospital.",
    rating: 5,
    image: "/images/testimonials/rahul_priya.jpg"
  },
  {
    id: "t3",
    patient_name: "Farhan Ali",
    role: "Post-surgery recovery",
    quote: "From my first consultation to recovery, everyone treated me with dignity. The follow-up calls made all the difference.",
    rating: 5,
    image: "/images/testimonials/farhan_ali.jpg"
  },
  {
    id: "t4",
    patient_name: "Kavya Menon",
    role: "Pediatric parent",
    quote: "Dr. Iyer has cared for both my children. She listens, she remembers, and my kids adore her.",
    rating: 5,
    image: "/images/testimonials/kavya_menon.jpg"
  }
];

export const BLOGS = [
  {
    id: "b1",
    title: "5 Everyday Habits That Protect Your Heart",
    slug: "heart-habits",
    excerpt: "Small changes in diet, sleep, and activity can dramatically lower your cardiac risk over time.",
    content: "Heart disease remains the leading cause of death globally, but the science is clear — small, consistent habits protect your heart far more than occasional heroics. Start with a 20-minute daily walk, add leafy greens to two meals a day, sleep 7 hours, keep salt below 5g, and check your BP monthly. If you have a family history, book a screening even without symptoms.\n\nStress is often overlooked. Chronic stress raises cortisol, which raises blood pressure. Practice a 4-7-8 breathing pattern twice a day. And finally — don't skip your follow-ups. Cardiac events are predictable when you're paying attention.",
    author: "Dr. Janak",
    category: "Cardiology",
    image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=1200&q=80",
    read_time: 4,
    published_at: "2026-02-10"
  },
  {
    id: "b2",
    title: "When to Take a Child's Fever Seriously",
    slug: "child-fever-guide",
    excerpt: "A simple, parent-friendly guide to knowing when a fever needs urgent care and when it doesn't.",
    content: "Most fevers in children are the body doing its job — fighting off a virus. But there are red flags every parent should know. For infants under 3 months, any fever above 38°C needs immediate attention. For older children, watch for lethargy, difficulty breathing, a stiff neck, or a rash that doesn't fade under pressure.\n\nHydration matters more than lowering the number on the thermometer. Offer small sips often. Paracetamol dosing should always be by weight, not age. And trust your instinct — if something feels off, call us. We'd rather reassure you than have you wait.",
    author: "Dr. Meera Iyer",
    category: "Pediatrics",
    image: "https://images.unsplash.com/photo-1518349619113-03114f06ac3a?w=1200&q=80",
    read_time: 5,
    published_at: "2026-02-05"
  },
  {
    id: "b3",
    title: "Understanding Stroke: The 4-Minute Rule",
    slug: "stroke-fast",
    excerpt: "How to recognize a stroke and why every minute of delay costs brain cells.",
    content: "Remember FAST — Face drooping, Arm weakness, Speech difficulty, Time to call emergency. Every minute of an untreated stroke destroys nearly 2 million neurons. Modern treatment can reverse damage if given within a 4.5-hour window, sometimes longer with newer clot-retrieval techniques.\n\nDon't drive yourself. Don't 'wait and see'. Call an ambulance — paramedics start treatment on the way. Know your risk factors: high BP, atrial fibrillation, diabetes, smoking, and family history all raise your chances. A neurologist visit once a year after 50 is a wise investment.",
    author: "Dr. Rohan Verma",
    category: "Neurology",
    image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=1200&q=80",
    read_time: 6,
    published_at: "2026-01-28"
  },
  {
    id: "b4",
    title: "Preparing for Joint Replacement: A Patient's Playbook",
    slug: "joint-replacement-guide",
    excerpt: "What to expect before, during, and after knee or hip replacement surgery.",
    content: "Joint replacement is one of the most successful surgeries in modern medicine — over 95% of patients report significant pain reduction and improved mobility. Preparation begins weeks before surgery. Strengthen your quadriceps, lose excess weight if possible, and organize your home for easy movement post-op.\n\nOn surgery day, expect to walk within hours. Recovery is faster than you'd guess — most patients climb stairs by week two. Physical therapy is non-negotiable. Skipping sessions is the single biggest predictor of poor outcomes. Follow the plan, and you'll be back on your feet.",
    author: "Dr. Karan Malhotra",
    category: "Orthopedics",
    image: "https://images.unsplash.com/photo-1583912267550-d6c2ac3196c0?w=1200&q=80",
    read_time: 5,
    published_at: "2026-01-20"
  },
  {
    id: "b5",
    title: "Cancer Screening: When to Start and Why It Matters",
    slug: "cancer-screening",
    excerpt: "Early detection saves lives. Here's the modern screening timeline by age and risk.",
    content: "Cancer caught early is often curable. Women should begin mammograms at 40 (earlier with family history), Pap tests at 21. Colonoscopy for everyone at 45. Men — a PSA discussion with your doctor from 50, or 45 if you have risk factors. Skin checks yearly if you've had sun exposure.\n\nScreening isn't scary — it's peace of mind. And it's often covered by insurance. Talk to your GP about a personalized screening plan. The best time to start was ten years ago. The second best time is today.",
    author: "Dr. Vikram Rao",
    category: "Oncology",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&q=80",
    read_time: 4,
    published_at: "2026-01-15"
  },
  {
    id: "b6",
    title: "The First Trimester: What's Normal, What's Not",
    slug: "first-trimester",
    excerpt: "A gentle guide for expecting mothers navigating the first 12 weeks.",
    content: "The first trimester is beautiful and bewildering. Fatigue, nausea, tender breasts, food aversions — all completely normal. Spotting can be normal too, but always call us to check. Take folic acid daily, avoid raw fish and unpasteurized dairy, and rest more than you think you need.\n\nYour first ultrasound around week 8-10 is a big moment. Bring your partner. Bring tissues. Prenatal vitamins matter, but so does joy — eat what nourishes you, walk when you can, and don't compare your pregnancy to anyone else's. Every one is different, and every one is a miracle.",
    author: "Dr. Sana Qureshi",
    category: "Maternity",
    image: "https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&q=80",
    read_time: 5,
    published_at: "2026-01-08"
  }
];
